<script>
import {
  getActiveStepComponent,
  registerStepComponent,
  getStepByComponent,
  getKeepState,
  getStep
} from './constant';

export default {
  name: 'WizardStep',
  inject: {
    getActiveStepComponent,
    registerStepComponent,
    getStepByComponent,
    getKeepState,
    getStep
  },
  computed: {
    step() {
      return this.getStep();
    },
    active() {
      return this.getActiveStepComponent() === this;
    },
    componentStep() {
      return this.getStepByComponent(this);
    },
    keepState() {
      return this.getKeepState();
    },
    shown() {
      return this.active || (this.componentStep < this.step && this.keepState);
    }
  },
  mounted() {
    this.unregister = this.registerStepComponent(this);
  },
  beforeUnmount() {
    this.unregister();
  },
  render() {
    if (!this.shown) {
      return null;
    }
    return this.$slots.default();
  }
};
</script>

<i18n lang="json">{}</i18n>
